export const ACCOUNT_SETTLEMENT_CONTINUATION_DELETE_RESET = 'ACCOUNT_SETTLEMENT_CONTINUATION_DELETE_RESET'
export const ACCOUNT_SETTLEMENT_CONTINUATION_DELETE_SET_ERROR = 'ACCOUNT_SETTLEMENT_CONTINUATION_DELETE_SET_ERROR'
export const ACCOUNT_SETTLEMENT_CONTINUATION_DELETE_SET_DELETED = 'ACCOUNT_SETTLEMENT_CONTINUATION_DELETE_SET_DELETED'
export const ACCOUNT_SETTLEMENT_CONTINUATION_DELETE_TOGGLE_LOADING = 'ACCOUNT_SETTLEMENT_CONTINUATION_DELETE_TOGGLE_LOADING'
